var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecurringComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reccompletea)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#E0E5EE"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#reccompleteb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#475569",
    d: "m9.385 4.147 1.803 1.803c.093.094.146.22.147.353v5.53a.167.167 0 0 1-.167.167h-6a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.863c.133 0 .26.053.354.147Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E5EE",
    fillRule: "evenodd",
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm.927-2.323a.25.25 0 0 0-.354-.354l-.823.823-.323-.323a.25.25 0 0 0-.354.354l.5.5a.25.25 0 0 0 .354 0l1-1Z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "reccompletea"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "reccompleteb"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h8v8H4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecurringComplete);
export default __webpack_public_path__ + "static/media/recurring-complete.6d3f0421e85dffae2cc527d5f45991f8.svg";
export { ForwardRef as ReactComponent };